import { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  Button,
  DatePicker,
  MultiSelect,
  MultiSelectItem,
  SearchSelect,
  SearchSelectItem,
  Select,
  SelectItem,
  TextInput,
} from "@tremor/react";
import { useForm, Controller, useWatch } from "react-hook-form";
import { ArrowUpTrayIcon } from "@heroicons/react/24/solid";
import { es } from "date-fns/locale";
import {
  PulsatingCircle,
  RegisterDriverModal,
  TitlePageInfo,
} from "../components";
import { useAPI } from "../../hooks";
import { getDrivers, getUsersApp } from "../../store/admin/thunks";
import { adminAPI } from "../../api/adminAPI";
import NotFoundImage from "../../assets/not-found.jpeg";
import { AlertBox } from "../../ui";
import { useNavigate } from "react-router-dom";
import CreatableSelect from "react-select/creatable";

const API = import.meta.env.VITE_UPLOADS_URL;

const CustomStatus = ({ status, setCustomStatusValue, customStatusValue }) => {
  const allCustomizable =
    status.isBlankInput && status.isCustomInput ? true : false;
  if (
    (customStatusValue === "" || customStatusValue === null) &&
    !allCustomizable
  ) {
    const actualDate = new Date();
    setCustomStatusValue(actualDate);
  }
  const handleDatePicker = (value, isDate = false) => {
    if (isDate) {
      const date = value;
      const year = value.getFullYear();
      const month = value.getMonth();
      const day = value.getDate();
      const dateModification = `${year}-${String(month).padStart(
        2,
        "0"
      )}-${String(day).padStart(2, "0")}`;
      value = dateModification;
    }

    setCustomStatusValue(value);
  };

  const handleInput = (event) => {
    setCustomStatusValue(event.target.value);
  };
  return (
    <div>
      <p>Estatus Customizable</p>
      {allCustomizable ? (
        <div>
          <TextInput
            placeholder="Ingrese el Estatus ..."
            onChange={handleInput}
            value={customStatusValue}
          />
        </div>
      ) : (
        <div>
          <DatePickerStatus
            value={new Date(customStatusValue)}
            handleDatePicker={(e) => handleDatePicker(e, true)}
          />
        </div>
      )}
    </div>
  );
};

const DatePickerStatus = ({ handleDatePicker, value }) => {
  return (
    <DatePicker
      locale={es}
      placeholder="Seleccionar Fecha"
      value={value}
      onValueChange={(e) => handleDatePicker(e, true)}
    ></DatePicker>
  );
};

export const FormServiceTrakingLayout = ({
  isEditMode = false,
  dataToEdit = {},
}) => {
  const { appUsers, drivers } = useSelector((state) => state.admin);
  const { get } = useAPI();
  const { jwt } = useSelector((state) => state.auth);
  const [idsDocumentsForDelete, setIdsDocumentsForDelete] = useState([]);
  const [observations, setObservations] = useState([]);
  const [comments, setComments] = useState([]);
  const [clients, setClients] = useState([]);
  const [buyers, setBuyers] = useState([]);
  const [status, setStatus] = useState([]);
  const [customStatus, setCustomStatus] = useState(null);
  const [customStatusValue, setCustomStatusValue] = useState(null);
  const [customObservation, setCustomObsertavion] = useState(null);
  const [customObservationValue, setCustomObsertavionValue] = useState("");
  const [showModal, setModal] = useState(false);
  const navigate = useNavigate();
  const [imagesSources, setImagesSources] = useState({
    diesel:
      isEditMode && dataToEdit.documents.length > 0 && dataToEdit.documents[0]
        ? {
            image: `${API}/${dataToEdit.documents[0].nameFile}`,
            id: dataToEdit.documents[0].id,
          }
        : {
            image: NotFoundImage,
            id: -1,
          },
    temp:
      isEditMode && dataToEdit.documents.length > 0 && dataToEdit.documents[1]
        ? {
            image: `${API}/${dataToEdit.documents[1].nameFile}`,
            id: dataToEdit.documents[1].id,
          }
        : {
            image: NotFoundImage,
            id: -1,
          },
    seal:
      isEditMode && dataToEdit.documents.length > 0 && dataToEdit.documents[2]
        ? {
            image: `${API}/${dataToEdit.documents[2].nameFile}`,
            id: dataToEdit.documents[2].id,
          }
        : {
            image: NotFoundImage,
            id: -1,
          },
  });
  const fileInputDiesel = useRef(null);
  const fileInputTemp = useRef(null);
  const fileInputSeal = useRef(null);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    control,
    getValues,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      sealFile: null,
      tempFile: null,
      dieselFile: null,
    },
  });
  const observationsIDs = useWatch({
    control,
    name: "observationsIDs",
    defaultValue: [],
  });

  const phytosanitaryPermission = useWatch({
    control,
    name: "phytosanitaryPermission",
    defaultValue: false,
  });

  const overweightPermission = useWatch({
    control,
    name: "overweightPermission",
    defaultValue: false,
  });

  // const basculePermission = useWatch({
  //   control,
  //   name: "basculePermission",
  //   defaultValue: false,
  // });

  const statusID = useWatch({
    control,
    name: "statusID",
    defaultValue: null,
  });

  useEffect(() => {
    comparaCustomObservation();
  }, [observationsIDs]);

  const onSubmit = async (dataForm) => {
    const { overweightPermission } = dataForm;
    if (
      overweightPermission &&
      (dataForm.overweightValue?.trim().length <= 0 ||
        dataForm.overweightValue === null)
    ) {
      AlertBox({
        color: "warning",
        messages: [
          "Tienes un Permiso de sobrepeso activo debes rellenar el campo.",
        ],
      });
      return;
    }

    const dataSend = { ...dataForm };
    // const dataSend = { ...dataForm, idsDocumentsForDelete };
    if (idsDocumentsForDelete.filter((id) => id !== -1).length > 0) {
      dataSend.idsDocumentsForDelete = idsDocumentsForDelete.filter(
        (id) => id !== -1
      );
    }

    if (customObservation) {
      if (customObservationValue.trim().length <= 0) {
        AlertBox({
          color: "warning",
          messages: [
            "Tienes una observación customizable debes rellenar el campo.",
          ],
        });
        return;
      }
      dataSend.customValueObservation = customObservationValue;
    }

    if (customStatus) {
      const valueNew = `${customStatusValue}`;
      if (valueNew.trim().length <= 0) {
        AlertBox({
          color: "warning",
          messages: ["Tienes un Estatus customizable debes rellenar el campo."],
        });
        return;
      }
      dataSend.customValueStatus = valueNew;
    }

    const headers = {
      "x-token": jwt,
      "Content-Type": "multipart/form-data",
    };
    const resp = await adminAPI
      .patch(`/services/${dataToEdit.id}`, dataSend, { headers })
      .catch(({ response }) => response);
    if (resp.status !== 200) {
      const errors = resp.data.errors && resp.data.errors.map((e) => e.msg);
      if (errors) {
        AlertBox({
          color: "error",
          messages: errors,
        });
        return;
      }

      AlertBox({
        color: "error",
        messages: ["Error al actualizar el servicio."],
      });
      return;
    }
    AlertBox({
      color: "success",
      messages: ["Servicio actualizado correctamente."],
    });

    if (resp.data.cleanupTriggered) {
      setTimeout(() => {
        AlertBox({
          color: "info",
          messages: [
            "Mantenimiento automático: Estamos liberando espacio de chats muy antiguos en segundo plano. Puedes continuar trabajando sin problemas."
          ],
        });
      }, 1500);
    }

    navigate("/admin/services");
  };

  const dataEditobservationsIDs = dataToEdit.servicesObservations.map(
    (s) => s.idObservations
  );

  useEffect(() => {
    setValue("clientID", isEditMode ? dataToEdit.clientID : null);
    setValue("buyerID", isEditMode ? dataToEdit.buyerID : null);
    setValue("invoiceNumber", isEditMode ? dataToEdit.invoiceNumber : "");
    setValue("travelNumber", isEditMode ? dataToEdit.travelNumber : "");
    setValue("economicCode", isEditMode ? dataToEdit.economicCode : "");
    setValue("feet", isEditMode ? dataToEdit.feet : "");
    setValue("driverID", isEditMode ? dataToEdit.driverID : null);
    setValue("phone", isEditMode ? dataToEdit.phone : "");
    setValue("CAAT", isEditMode ? dataToEdit.CAAT : "");
    setValue(
      "integrationNumber",
      isEditMode ? dataToEdit.integrationNumber : ""
    );
    setValue("plateNumber", isEditMode ? dataToEdit.plateNumber || "" : "");
    setValue("waybill", isEditMode ? dataToEdit.waybill : "");
    setValue("statusID", isEditMode ? dataToEdit.statusID : null);
    setValue("alphaCode", isEditMode ? dataToEdit.alphaCode : "");
    setValue(
      "compannyComment",
      isEditMode && dataToEdit.compannyComment
        ? dataToEdit.compannyComment
        : null
    );
    setValue(
      "phytosanitaryPermission",
      isEditMode ? dataToEdit.phytosanitaryPermission : false
    );
    setValue(
      "observationsIDs",
      isEditMode && dataToEdit.servicesObservations.length > 0
        ? dataEditobservationsIDs
        : []
    );
    setValue(
      "overweightPermission",
      isEditMode ? dataToEdit.overweightPermission : false
    );
    setValue(
      "basculePermission",
      isEditMode ? dataToEdit.basculePermission : false
    );
    setValue(
      "requirementNumber",
      isEditMode ? dataToEdit.requirementNumber : ""
    );
    setValue(
      "remesas",
      isEditMode ? dataToEdit.remesas : ""
    );
    setValue("basculeValue", isEditMode ? dataToEdit.basculeValue : "");
    setValue("overweightValue", isEditMode ? dataToEdit.overweightValue : "");
    setValue(
      "phytosanitaryValue",
      isEditMode ? dataToEdit.phytosanitaryValue : ""
    );
    setValue("moduleStatus", isEditMode ? dataToEdit.moduleStatus : "");
    setValue("dateDelivery", isEditMode ? dataToEdit.dateDelivery : "");
    setValue("creationDate", isEditMode && dataToEdit.creationDate ? new Date(dataToEdit.creationDate) : null);
  }, [buyers]);

  const getStatus = async () => {
    const resp = await adminAPI
      .get("/status")
      .catch(({ response }) => response);
    if (resp.status !== 200) return;
    const { data } = resp.data;
    setStatus(data);
  };

  const getObservations = async () => {
    const { data, isSuccess } = await get("/observations");
    if (!isSuccess) return;
    setObservations(data.data);
  };

  const compareCustomStatus = () => {
    const customStatus = status.find(
      (s) => s.id === statusID && s.isCustomInput === true
    );
    if (!customStatus) {
      setCustomStatus(null);
      return;
    }

    setCustomStatus(customStatus);

    if (dataToEdit.logsStatusServices.length <= 0) return;

    const statusInData = dataToEdit.logsStatusServices.find(
      (s) => s.idStatusServices === customStatus.id
    );

    if (!statusInData) {
      setCustomStatusValue(null);
      return;
    }
    const isADate = new Date(statusInData.customMessage);
    if (isADate instanceof Date && !isNaN(isADate)) {
      setCustomStatusValue(isADate);
      return;
    }
    setCustomStatusValue(statusInData.customMessage);
  };

  const comparaCustomObservation = () => {
    const customObservation = observations.find(
      (o) => observationsIDs.includes(o.id) && o.isCustom
    );
    if (!customObservation) {
      setCustomObsertavion(null);
      return;
    }
    setCustomObsertavion(customObservation);
    if (dataToEdit.servicesObservations.length <= 0) return;
    const serviceCustom = dataToEdit.servicesObservations.find(
      (s) => s.idObservations === customObservation.id
    );
    if (serviceCustom) {
      setCustomObsertavionValue(serviceCustom.customMessage);
      return;
    }
    setCustomObsertavionValue("");
  };

  const getComments = async () => {
    const { data, isSuccess } = await get("/comments");
    if (!isSuccess) return;
    setComments(data.data);
  };

  useEffect(() => {
    const buyersUsers = appUsers.filter((data) => data.isBuyer === true);
    const clientsUsers = appUsers.filter((data) => data.isBuyer === false);
    setClients(clientsUsers);
    setBuyers(buyersUsers);
  }, [appUsers]);

  useEffect(() => {
    getStatus();
    getObservations();
    getComments();
    dispatch(getDrivers());
    dispatch(getUsersApp());
  }, []);

  useEffect(() => {
    compareCustomStatus();
  }, [status, statusID]);

  const showModalDriver = () => {
    setModal(!showModal);
  };

  const handleFileInput = (inputRef) => {
    inputRef.current.click();
  };

  const handleFileChange = (inputType) => (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      setValue(`${inputType}File`, file);
      setImagesSources((prevState) => {
        setIdsDocumentsForDelete((prev) => [...prev, prevState[inputType]?.id]);

        return {
          ...prevState,
          [inputType]: {
            id: 0,
            image: e.target.result,
          },
        };
      });
    };
    reader.readAsDataURL(file);
  };

  // Tema actual (claro/oscuro) sincronizado con clase `dark` y preferencia del sistema
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const getIsDark = () =>
      document.documentElement.classList.contains('dark') ||
      (typeof window !== 'undefined' &&
        window.matchMedia &&
        window.matchMedia('(prefers-color-scheme: dark)').matches);

    setIsDarkMode(getIsDark());

    // Reaccionar a cambios del sistema
    const mql = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
    const mqlListener = (e) => setIsDarkMode(e.matches || document.documentElement.classList.contains('dark'));
    if (mql && mql.addEventListener) mql.addEventListener('change', mqlListener);

    // Observar cambios de la clase `dark` en html
    const observer = new MutationObserver(() => setIsDarkMode(getIsDark()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    return () => {
      if (mql && mql.removeEventListener) mql.removeEventListener('change', mqlListener);
      observer.disconnect();
    };
  }, []);

  // Estilos del select coherentes con el tema activo
  const selectStyles = useMemo(() => {
    const colors = isDarkMode
      ? {
          bg: '#0b1220',
          bgHover: '#111827',
          border: '#374151',
          text: '#e5e7eb',
          placeholder: '#9ca3af',
          sep: '#374151',
        }
      : {
          bg: '#ffffff',
          bgHover: '#f3f4f6',
          border: '#e5e7eb',
          text: '#111827',
          placeholder: '#6b7280',
          sep: '#e5e7eb',
        };

    return {
      control: (base, state) => ({
        ...base,
        backgroundColor: colors.bg,
        borderColor: colors.border,
        boxShadow: 'none',
        minHeight: 42,
        borderRadius: 8,
        color: colors.text,
        '&:hover': { borderColor: colors.border },
      }),
      singleValue: (base) => ({ ...base, color: colors.text }),
      placeholder: (base) => ({ ...base, color: colors.placeholder }),
      input: (base) => ({ ...base, color: colors.text }),
      menu: (base) => ({ ...base, backgroundColor: colors.bg, color: colors.text }),
      menuList: (base) => ({ ...base, backgroundColor: colors.bg }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? colors.bgHover : colors.bg,
        color: colors.text,
        '&:active': { backgroundColor: colors.bgHover },
      }),
      dropdownIndicator: (base) => ({ ...base, color: colors.placeholder }),
      clearIndicator: (base) => ({ ...base, color: colors.placeholder }),
      indicatorSeparator: (base) => ({ ...base, backgroundColor: colors.sep }),
      valueContainer: (base) => ({ ...base, paddingTop: 6, paddingBottom: 6 }),
    };
  }, [isDarkMode]);

  return (
    <>
      {showModal ? (
        <RegisterDriverModal cancelFunction={showModalDriver} />
      ) : (
        <></>
      )}
      <TitlePageInfo title="Seguimiento de Servicio" />
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <p>Cliente</p>
          {clients.length <= 0 ? (
            <p>No hay clientes registrados</p>
          ) : (
            <Controller
              name="clientID"
              control={control}
              rules={{ required: "Cliente es requerido" }}
              render={({ field }) => (
                <SearchSelect placeholder="Seleccionar..." {...field}>
                  {clients.map((client) => (
                    <SearchSelectItem key={client.id} value={client.id}>
                      {client.name} - {client.email}
                    </SearchSelectItem>
                  ))}
                </SearchSelect>
              )}
            />
          )}
        </div>

        <div>
          <p>Comprador</p>
          {buyers.length <= 0 ? (
            <p>No hay compradores registrados</p>
          ) : (
            <Controller
              name="buyerID"
              control={control}
              rules={{ required: "Comprador es requerido" }}
              render={({ field }) => (
                <SearchSelect placeholder="Seleccionar..." {...field}>
                  {buyers.map((buyer) => (
                    <SearchSelectItem key={buyer.id} value={buyer.id}>
                      {buyer.name} - {buyer.email}
                    </SearchSelectItem>
                  ))}
                </SearchSelect>
              )}
            />
          )}
        </div>
        <div className="grid grid-cols-4 gap-2">
          {isEditMode && (
            <div className="col-span-4">
              <p>Fecha del Servicio</p>
              <Controller
                name="creationDate"
                control={control}
                render={({ field }) => (
                  <DatePicker
                    locale={es}
                    placeholder="Seleccionar Fecha del Servicio"
                    value={field.value ? new Date(field.value) : null}
                    onValueChange={field.onChange}
                    className="w-full"
                  />
                )}
              />
            </div>
          )}
          <div>
            <p>Factura</p>
            <TextInput
              placeholder="Numero de Factura"
              name="invoiceNumber"
              {...register("invoiceNumber", {
                required: {
                  value: true,
                  message: "Debe contener el número de factura",
                },
              })}
            />
            {errors.invoiceNumber && (
              <span className="text-red-500 text-xs italic">
                {errors.invoiceNumber.message}
              </span>
            )}
          </div>
          <div>
            <p>Número de Viaje</p>
            <TextInput
              placeholder="1234-ABC"
              name="travelNumber"
              {...register("travelNumber", {
                required: {
                  value: true,
                  message: "Debe contener el número de viaje",
                },
              })}
            />
            {errors.travelNumber && (
              <span className="text-red-500 text-xs italic">
                {errors.travelNumber.message}
              </span>
            )}
          </div>
          <div>
            <p>Número Económico</p>
            <TextInput
              placeholder="ABC-1234"
              name="economicCode"
              {...register("economicCode", {
                required: {
                  value: true,
                  message: "Debe contener el número económico",
                },
                minLength: {
                  value: 1,
                  message: "Numero Económico debe tener al menos 1 caracteres",
                },
              })}
            />
            {errors.economicCode && (
              <span className="text-red-500 text-xs italic">
                {errors.economicCode.message}
              </span>
            )}
          </div>
          <div>
            <p>Pies</p>
            <TextInput
              placeholder="3,4 ft"
              name="feet"
              {...register("feet", {
                required: {
                  value: true,
                  message: "Debe contener los pies",
                },
              })}
            />
            {errors.feet && (
              <span className="text-red-500 text-xs italic">
                {errors.feet.message}
              </span>
            )}
          </div>
          <div>
            <p>Conductor</p>
            <Controller
              name="driverID"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: "Conductor es requerido",
                },
                validate: {
                  isDifferent: (value) => value !== "-1",
                },
              }}
              render={({ field }) => (
                <SearchSelect placeholder="Seleccionar..." {...field}>
                  <SearchSelectItem value="-1" onClick={showModalDriver}>
                    Registrar Nuevo Conductor
                  </SearchSelectItem>
                  {drivers.map((d) => (
                    <SearchSelectItem key={d.id} value={d.id}>
                      {d.name}
                    </SearchSelectItem>
                  ))}
                </SearchSelect>
              )}
            />
            {errors.driverID && (
              <span className="text-red-500 text-xs italic">
                {errors.driverID.message}
              </span>
            )}
          </div>
          <div className="col-span-2">
            <p>Celular</p>
            <TextInput
              placeholder="81 0000 0000"
              name="phone"
              {...register("phone", {
                required: {
                  value: true,
                  message: "Telefono es requerido",
                },
                maxLength: {
                  value: 10,
                  message: "Debe contener 10 caracteres",
                },
                minLength: {
                  value: 10,
                  message: "Debe contener 10 caracteres",
                },
                pattern: {
                  value: /^[0-9]*$/,
                  message: "Solo se permiten números",
                },
              })}
            />
            {errors.phone && (
              <span className="text-red-500 text-xs italic">
                {errors.phone.message}
              </span>
            )}
          </div>
          <div>
            <p>CAAT</p>
            <TextInput
              name="CAAT"
              placeholder="1234"
              {...register("CAAT", {
                required: {
                  value: true,
                  message: "Debe contener el CAAT",
                },
              })}
            />
            {errors.CAAT && (
              <span className="text-red-500 text-xs italic">
                {errors.CAAT.message}
              </span>
            )}
          </div>
          <div>
            <p>No. Integración</p>
            <TextInput
              placeholder="1234"
              name="integrationNumber"
              {...register("integrationNumber", {
                required: {
                  value: true,
                  message: "Debe contener el número de integración",
                },
              })}
            />
            {errors.integrationNumber && (
              <span className="text-red-500 text-xs italic">
                {errors.integrationNumber.message}
              </span>
            )}
          </div>
          <div>
            <p>No. Placa</p>
            <TextInput
              placeholder="1234"
              name="plateNumber"
              {...register("plateNumber", {
                required: {
                  value: true,
                  message: "Debe contener el número de placa",
                },
              })}
            />
            {errors.plateNumber && (
              <span className="text-red-500 text-xs italic">
                {errors.plateNumber.message}
              </span>
            )}
          </div>
          <div>
            <p>Carta Porte </p>
            <TextInput
              placeholder="ABC123"
              name="waybill"
              {...register("waybill", {
                required: {
                  value: true,
                  message: "Debe contener la carta porte",
                },
              })}
            />
          </div>
          <div>
            <p>Estatus</p>
            {status ? (
              <Controller
                name="statusID"
                control={control}
                rules={{
                  required: {
                    value: true,
                    message: "Estatus es requerido",
                  },
                }}
                render={({ field }) => {
                  const options = status.map((s) => ({
                    value: s.id,
                    label: s.name,
                  }));

                  const handleCreate = async (inputValue) => {
                    const headers = { "x-token": jwt };
                    const resp = await adminAPI
                      .post("/status", { name: inputValue, isCustomInput: false, isBlankInput: false }, { headers })
                      .catch(({ response }) => response);
                    if (resp.status !== 200) {
                      const data = resp.data;
                      const errors = data?.message
                        ? [data.message]
                        : data?.errors?.map((e) => e.msg) || [
                            "Error al crear el estatus",
                          ];
                      AlertBox({ color: "warning", messages: errors });
                      return;
                    }
                    const refresh = await adminAPI
                      .get("/status")
                      .catch(({ response }) => response);
                    if (refresh.status === 200) {
                      const newList = refresh.data?.data || [];
                      setStatus(newList);
                      const created = newList.find(
                        (s) => s.name.toLowerCase() === inputValue.toLowerCase()
                      );
                      if (created) field.onChange(created.id);
                    }
                    AlertBox({
                      color: "success",
                      messages: [
                        resp.data?.message || "Estatus creado correctamente",
                      ],
                    });
                  };

                  return (
                    <CreatableSelect
                      isClearable
                      placeholder="Seleccionar o escribir..."
                      options={options}
                      value={
                        options.find((o) => o.value === field.value) || null
                      }
                      onChange={(opt) => field.onChange(opt ? opt.value : null)}
                      onCreateOption={handleCreate}
                      className="w-full"
                      classNamePrefix="rs"
                      styles={selectStyles}
                    />
                  );
                }}
              />
            ) : (
              <></>
            )}
            {errors.statusID && (
              <span className="text-red-500 text-xs italic">
                {errors.statusID.message}
              </span>
            )}
          </div>

          {customStatus ? (
            <CustomStatus
              status={customStatus}
              setCustomStatusValue={setCustomStatusValue}
              customStatusValue={customStatusValue}
            />
          ) : (
            <></>
          )}
          <div>
            <p>Número de Pedimento</p>
            <TextInput
              placeholder="1234"
              name="requirementNumber"
              {...register("requirementNumber", {
                required: {
                  value: true,
                  message: "Debe contener el número de pedimento",
                },
                minLength: {
                  value: 1,
                  message: "Debe contener al menos 1 caracteres",
                },
              })}
            />
            {errors.requirementNumber && (
              <span className="text-red-500 text-xs italic">
                {errors.requirementNumber.message}
              </span>
            )}
          </div>
          <div>
            <p>Remesas</p>
            <TextInput
              placeholder="Remesas..."
              name="remesas"
              {...register("remesas")}
            />
          </div>
          <div>
            <p>Codigo Alfa</p>
            <TextInput
              placeholder="1234-ABCD"
              name="alphaCode"
              {...register("alphaCode", {
                required: {
                  value: true,
                  message: "Debe contener el código alfa",
                },
              })}
            />
            {errors.alphaCode && (
              <span className="text-red-500 text-xs italic">
                {errors.alphaCode.message}
              </span>
            )}
          </div>
          <div>
            {/* //TODO: Finish this */}
            <p>Modulo</p>
            <div className="flex items-center">
              <PulsatingCircle status={dataToEdit.moduleStatus} />
              <p className="ml-4">{dataToEdit.moduleStatus ?? "SIN MODULO"}</p>
            </div>
          </div>
          <div>
            <p>Observaciones</p>
            <Controller
              name="observationsIDs"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: "Observaciones es requerido",
                },
              }}
              render={({ field }) => (
                <MultiSelect placeholder="Seleccionar..." {...field}>
                  {observations.map((o) => (
                    <MultiSelectItem key={o.id} value={o.id}>
                      {o.name}
                    </MultiSelectItem>
                  ))}
                </MultiSelect>
              )}
            />
            {errors.observationsIDs && (
              <span className="text-red-500 text-xs italic">
                {errors.observationsIDs.message}
              </span>
            )}
          </div>
          <div>
            {customObservation ? (
              <div>
                <p>Ingrese la Observación</p>
                <TextInput
                  placeholder="Observación..."
                  onKeyUp={(e) => setCustomObsertavionValue(e.target.value)}
                  {...register("customValueObservation", {
                    required: {
                      value: true,
                      message: "Observación es requerido",
                    },
                    value: customObservationValue,
                  })}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
          <div>
            <p>Documentos</p>
            <TextInput
              placeholder="Documento..."
              name="compannyComment"
              {...register("compannyComment", {
                required: {
                  value: true,
                  message: "Documento es requerido",
                },
                minLength: {
                  value: 3,
                  message: "Debe contener al menos 3 caracteres",
                },
              })}
            />
            {errors.compannyComment && (
              <span className="text-red-500 text-xs italic">
                {errors.compannyComment.message}
              </span>
            )}
          </div>
          <div>
            <p>Permisos</p>
            <ul>
              <li>
                <label>
                  <input
                    type="checkbox"
                    name="phytosanitaryPermission"
                    {...register("phytosanitaryPermission")}
                  />
                  <span className="ml-1">Fitosanitario</span>
                </label>
                {phytosanitaryPermission ? (
                  <TextInput
                    placeholder="Número de Fitosanitario"
                    type="number"
                    {...register("phytosanitaryValue")}
                  />
                ) : (
                  <></>
                )}
              </li>
              <li>
                <label>
                  <input
                    type="checkbox"
                    name="overweightPermission"
                    {...register("overweightPermission")}
                  />
                  <span className="ml-1">Permiso de sobrepeso</span>
                </label>
                {overweightPermission ? (
                  <TextInput
                    placeholder="Exceso de Peso"
                    type="number"
                    {...register("overweightValue")}
                  />
                ) : (
                  <></>
                )}
              </li>
              <li>
                <label>
                  <input
                    type="checkbox"
                    name="basculePermission"
                    {...register("basculePermission")}
                  />
                  <span className="ml-1">Báscula</span>
                  {errors.basculePermission && (
                    <span className="text-red-500 text-xs italic">
                      {errors.basculePermission.message}
                    </span>
                  )}
                </label>
                {/* {basculePermission ? (
                  <TextInput
                    placeholder="Peso en Báscula"
                    type="number"
                    {...register("basculeValue")}
                  />
                ) : (
                  <></>
                )} */}
              </li>
            </ul>
          </div>
          <div className="col-span-3" style={{ marginTop: '-30px' }}>
            <p>Fecha y hora de entrega de documentos</p>
            <TextInput
              placeholder="Fecha y hora de entrega..."
              name="dateDelivery"
              {...register("dateDelivery", {
                required: {
                  value: false,
                  message: "Fecha y hora de entrega no es requerido",
                },
                minLength: {
                  value: 3,
                  message: "Debe contener al menos 3 caracteres",
                },
              })}
            />
            {errors.dateDelivery && (
              <span className="text-red-500 text-xs italic">
                {errors.dateDelivery.message}
              </span>
            )}
          </div>
          <div></div>
          <div className="mt-2">
            <p className="font-bold">Diesel</p>
            <img src={imagesSources.diesel.image} className="w-32 h-32" />
            <input
              type="file"
              accept="image/*"
              className="hidden"
              ref={fileInputDiesel}
              // data-id={imagesSources.diesel.id}
              onChange={handleFileChange("diesel")}
            />
            <Button
              type="button"
              icon={ArrowUpTrayIcon}
              className="mt-2"
              onClick={() => handleFileInput(fileInputDiesel)}
            >
              Seleccionar
            </Button>
          </div>
          <div className="mt-2">
            <p className="font-bold">Temperatura</p>
            <img src={imagesSources.temp.image} className="w-32 h-32" />
            <input
              type="file"
              accept="image/*"
              className="hidden"
              ref={fileInputTemp}
              onChange={handleFileChange("temp")}
            />
            <Button
              type="button"
              icon={ArrowUpTrayIcon}
              className="mt-2"
              onClick={() => handleFileInput(fileInputTemp)}
            >
              Seleccionar
            </Button>
          </div>
          <div className="mt-2">
            <p className="font-bold">Sello</p>
            <img src={imagesSources.seal.image} className="w-32 h-32" />
            <input
              type="file"
              accept="image/*"
              className="hidden"
              ref={fileInputSeal}
              onChange={handleFileChange("seal")}
            />
            <Button
              type="button"
              icon={ArrowUpTrayIcon}
              className="mt-2"
              onClick={() => handleFileInput(fileInputSeal)}
            >
              Seleccionar
            </Button>
          </div>
        </div>
        <div className="flex justify-end">
          <Button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Guardando..." : "Guardar"}
          </Button>
        </div>
      </form>
    </>
  );
};

FormServiceTrakingLayout.propTypes = {
  isEditMode: PropTypes.bool,
  dataToEdit: PropTypes.object,
};
